import MarkdownIt from 'markdown-it'
import removeMarkdown from 'remove-markdown'

/**
 * Renders markdown to HTML.
 *
 * @param md
 */
export function markdownToHtml(md: string): string {
  const markdownInstance = new MarkdownIt({ linkify: true, breaks: true })
  const html = markdownInstance.render(md)
  return html.replace(/<a href=/gi, '<a target="_blank" href=')
}

/**
 * Strips markdown from the specified string.
 *
 * @param md
 */
export function stripMarkdown(md: string) {
  const plainText = removeMarkdown(md, {
    stripListLeaders: false,
  })
  return plainText
}
